import { render, staticRenderFns } from "./mainApp.vue?vue&type=template&id=4ecf4188"
import script from "./mainApp.vue?vue&type=script&lang=js"
export * from "./mainApp.vue?vue&type=script&lang=js"
import style0 from "./mainApp.vue?vue&type=style&index=0&id=4ecf4188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports